var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgName(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 187.499995",
    height: 250,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("clipPath", {
    id: "35de106674"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.5 106 L 10 106 L 10 129 L 0.5 129 Z M 0.5 106 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8d6294bb1d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.5 64 L 10 64 L 10 88 L 0.5 88 Z M 0.5 64 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: 337208964
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.5 119 L 44 119 L 44 129 L 0.5 129 Z M 0.5 119 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2194a5ad05"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.5 92 L 44 92 L 44 102 L 0.5 102 Z M 0.5 92 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "25f963dd18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.5 64 L 44 64 L 44 74 L 0.5 74 Z M 0.5 64 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#182826",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.983857, 126.981336)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 15.765625 -40.125 L 16.015625 -33.375 L 16.015625 0 L 6.578125 0 L 6.578125 -62.046875 L 7.75 -62.046875 L 44.171875 -21.40625 L 43.828125 -28.5 L 43.828125 -61.953125 L 53.28125 -61.953125 L 53.28125 0 L 52.015625 0 Z M 15.765625 -40.125 "
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#193b38",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(110.064966, 126.857484)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M -1.34375 -61.953125 L 9.359375 -61.953125 L 27.90625 -19.390625 L 46.53125 -61.953125 L 57.15625 -61.953125 L 28.578125 0 L 27.3125 0 Z M -1.34375 -61.953125 "
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#1a4d4b",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(174.258737, 126.857484)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 7.671875 -61.953125 L 17.109375 -61.953125 L 17.109375 0 L 7.671875 0 Z M 7.671875 -61.953125 "
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#1d7270",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(240.847296, 126.857484)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 35.0625 0.84375 C 29.445312 0.84375 24.265625 -0.460938 19.515625 -3.078125 C 14.765625 -5.691406 10.984375 -9.414062 8.171875 -14.25 C 5.367188 -19.082031 3.96875 -24.703125 3.96875 -31.109375 C 3.96875 -37.566406 5.367188 -43.195312 8.171875 -48 C 10.984375 -52.8125 14.765625 -56.507812 19.515625 -59.09375 C 24.265625 -61.675781 29.445312 -62.96875 35.0625 -62.96875 C 40.6875 -62.96875 45.875 -61.675781 50.625 -59.09375 C 55.375 -56.507812 59.148438 -52.8125 61.953125 -48 C 64.765625 -43.195312 66.171875 -37.566406 66.171875 -31.109375 C 66.171875 -24.703125 64.765625 -19.082031 61.953125 -14.25 C 59.148438 -9.414062 55.375 -5.691406 50.625 -3.078125 C 45.875 -0.460938 40.6875 0.84375 35.0625 0.84375 Z M 35.0625 -7.671875 C 38.945312 -7.671875 42.488281 -8.582031 45.6875 -10.40625 C 48.894531 -12.238281 51.4375 -14.910156 53.3125 -18.421875 C 55.195312 -21.929688 56.140625 -26.128906 56.140625 -31.015625 C 56.140625 -35.960938 55.195312 -40.191406 53.3125 -43.703125 C 51.4375 -47.210938 48.910156 -49.867188 45.734375 -51.671875 C 42.554688 -53.472656 39 -54.375 35.0625 -54.375 C 31.132812 -54.375 27.566406 -53.472656 24.359375 -51.671875 C 21.160156 -49.867188 18.632812 -47.210938 16.78125 -43.703125 C 14.925781 -40.191406 14 -35.960938 14 -31.015625 C 14 -26.128906 14.953125 -21.929688 16.859375 -18.421875 C 18.765625 -14.910156 21.332031 -12.238281 24.5625 -10.40625 C 27.800781 -8.582031 31.300781 -7.671875 35.0625 -7.671875 Z M 35.0625 -7.671875 "
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#1b5f5d",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(206.936708, 126.857484)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 7.671875 -61.953125 L 17.109375 -61.953125 L 17.109375 0 L 7.671875 0 Z M 7.671875 -61.953125 "
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#238481",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(319.213869, 126.981336)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 15.765625 -40.125 L 16.015625 -33.375 L 16.015625 0 L 6.578125 0 L 6.578125 -62.046875 L 7.75 -62.046875 L 44.171875 -21.40625 L 43.828125 -28.5 L 43.828125 -61.953125 L 53.28125 -61.953125 L 53.28125 0 L 52.015625 0 Z M 15.765625 -40.125 "
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#35de106674)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.000000000000000046, 0.160886, -0.160886, 0.000000000000000046, 9.524383, 111.204095)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M -0.00603004 28.000263 L 82.01049 28.000263 ",
    stroke: "#181613",
    strokeWidth: 56,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8d6294bb1d)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0, 0.160886, -0.160886, 0, 9.524383, 69.373726)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.0079203 28.000263 L 82.00016 28.000263 ",
    stroke: "#181613",
    strokeWidth: 56,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0337208964)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.160897, 0, 0, 0.160886, 0.498675, 119.891936)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.008232 28.010522 L 238.005601 28.010522 ",
    stroke: "#181613",
    strokeWidth: 56,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2194a5ad05)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.160865, 0, 0, 0.160886, 0.498675, 92.380434)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.00823362 28.009175 L 238.0282 28.009175 ",
    stroke: "#181613",
    strokeWidth: 56,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#25f963dd18)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.160897, 0, 0, 0.160886, 0.498675, 64.868915)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.008232 28.007932 L 238.005601 28.007932 ",
    stroke: "#181613",
    strokeWidth: 56,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgName);
export default __webpack_public_path__ + "static/media/Name.f4b0a26f3a4bdac8e65e42f42be810c6.svg";
export { ForwardRef as ReactComponent };